import oktaJQueryStatic from "./jquery-wrapper.js";
import oktaUnderscore from "./underscore-wrapper.js";
import BaseRouter from "./BaseRouter.js";
import SettingsModel from "./SettingsModel.js";
import StateMachine from "./StateMachine.js";
import BaseView from "../views/BaseView.js";
function clean(obj) {
  const res = {};
  oktaUnderscore.each(obj, function(value, key) {
    if (!oktaUnderscore.isNull(value)) {
      res[key] = value;
    }
  });
  return res;
}
const proto = (
  /** @lends module:Okta.Controller.prototype */
  {
    preinitialize: function(options = {}) {
      this.state = oktaUnderscore.result(this, "state");
      const hasStateBeenInitialized = this.state instanceof StateMachine || options.state instanceof StateMachine;
      if (!hasStateBeenInitialized) {
        const stateData = oktaUnderscore.defaults(clean(options.state), this.state || {});
        this.state = new StateMachine(stateData);
        delete options.state;
      }
      if (!options.settings) {
        options.settings = new SettingsModel(oktaUnderscore.omit(options || {}, "el"));
        this.listen("notification", BaseRouter.prototype._notify);
        this.listen("confirmation", BaseRouter.prototype._confirm);
      }
      BaseView.prototype.preinitialize.call(this, options);
    },
    constructor: function(options = {}) {
      BaseView.call(this, options);
      this.listenTo(this.state, "__invoke__", function() {
        const args = oktaUnderscore.toArray(arguments);
        const method = args.shift();
        if (oktaUnderscore.isFunction(this[method])) {
          this[method].apply(this, args);
        }
      });
      let MainView;
      if (this.View && this.View.isCourageView) {
        MainView = this.View;
      } else if (oktaUnderscore.result(this, "View") && oktaUnderscore.result(this, "View").isCourageView) {
        MainView = oktaUnderscore.result(this, "View");
      }
      if (MainView) {
        this.add(new MainView(this.toJSON()));
      }
    },
    /**
     * The default values of our application state
     * @type {Object}
     * @default {}
     */
    state: {},
    /**
     * The main view this controller operate on
     * @type {module:Okta.View}
     * @default null
     */
    View: null,
    /**
     * Renders the {@link module:Okta.Controller#View|main view} after the DOM is ready
     * in case the controller is the root component of the page (e.g there's no router)
     */
    render: function() {
      const args = arguments;
      const self = this;
      oktaJQueryStatic(function() {
        BaseView.prototype.render.apply(self, args);
      });
      return this;
    },
    /**
     * Creates the view constructor options
     * @param {Object} [options] Extra options
     * @return {Object} The view constructor options
     */
    toJSON: function(options) {
      return oktaUnderscore.extend(oktaUnderscore.pick(this, "state", "settings", "collection", "model"), options || {});
    },
    /**
     * Removes the child views, empty the DOM element and stop listening to events
     */
    remove: function() {
      this.removeChildren();
      this.stopListening();
      this.$el.empty();
      return this;
    }
  }
);
var BaseController = BaseView.extend(proto);
export { BaseController as default };
